import type { AppIconProps } from '../Icons.types';

export const AppAlertIcon = ({ className, ...props }: AppIconProps) => {
  return (
    <svg
      {...props}
      className={className}
      width="18"
      height="17"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.5 1.66995C9.25413 2.10537 9.88147 2.73021 10.3199 3.4826C10.7583 4.23498 10.9927 5.08883 10.9997 5.95962C11.0067 6.8304 10.7862 7.68792 10.36 8.4473C9.93378 9.20667 9.31662 9.84155 8.56962 10.2891C7.82262 10.7367 6.97168 10.9814 6.10105 10.999C5.23041 11.0166 4.37027 10.8065 3.60578 10.3896C2.84128 9.97261 2.19894 9.36321 1.74233 8.62171C1.25438 7.82929 1.0143 6.92658 1 5.99995C1.01419 5.08016 1.25066 4.18392 1.73182 3.39544C2.18187 2.65796 2.81533 2.04967 3.57045 1.62989C4.32556 1.2101 5.17657 0.993145 6.0405 1.00017C6.90443 1.00719 7.7518 1.23795 8.5 1.66995Z"
        fill="#FF7777"
      />
      <path
        d="M6.005 7.5L5.9415 7.5035C5.81998 7.51795 5.70797 7.57648 5.62671 7.66798C5.54544 7.75949 5.50056 7.87762 5.50056 8C5.50056 8.12238 5.54544 8.24051 5.62671 8.33202C5.70797 8.42352 5.81998 8.48205 5.9415 8.4965L6 8.5L6.0635 8.4965C6.18502 8.48205 6.29703 8.42352 6.37829 8.33202C6.45956 8.24051 6.50444 8.12238 6.50444 8C6.50444 7.87762 6.45956 7.75949 6.37829 7.66798C6.29703 7.57648 6.18502 7.51795 6.0635 7.5035L6.005 7.5ZM6 3.5C5.87753 3.50002 5.75933 3.54498 5.66781 3.62636C5.5763 3.70774 5.51783 3.81987 5.5035 3.9415L5.5 4V6L5.5035 6.0585C5.51796 6.18002 5.57648 6.29203 5.66798 6.37329C5.75949 6.45456 5.87762 6.49944 6 6.49944C6.12238 6.49944 6.24051 6.45456 6.33202 6.37329C6.42352 6.29203 6.48204 6.18002 6.4965 6.0585L6.5 6V4L6.4965 3.9415C6.48217 3.81987 6.4237 3.70774 6.33219 3.62636C6.24067 3.54498 6.12247 3.50002 6 3.5Z"
        fill="white"
      />
    </svg>
  );
};
